import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { Focus } from '@fenderdigital/ui/utils/css';
import Link from '../../Link';

export const Container = styled.div`
  position: absolute;
  width: 100%;
  height: calc(100vh - 3rem);
  overflow: hidden;
  z-index: 2;
  background-color: ${({ theme }): string => theme.colors.white};

  top: 3.71rem;
  right: 0;

  ${up('tablet-portrait')} {
    top: 4.1rem;
    right: 7.9rem;
    width: 23.938rem;
    height: calc(100vh - 8.4375rem);
    max-height: 50.125rem;
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.18);
  }
`;

export const MetaWrapper = styled.div`
  position: absolute;
  inset: 0;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  padding: 1rem 1rem 0;
  bottom: 1rem;
  width: 100%;
  background-color: white;
`;

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 3.75rem;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(100vh - 3.5rem);
  width: 100vw;
  z-index: 1;
`;

export const Button = styled(Link)<{ height?: string }>`
  width: 100%;
  height: ${({ height }): string => height ?? '3.125rem'};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1.5rem;
  background-color: black;

  ${Focus}
`;
